import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";
import { customBlue } from "../../theme/palette";

export const ResetSubmissionIcon = ({ stroke, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.62 10.8571L5 15.4286L9.62 20M5 15.4286L11.16 15.4286L13.2857 15.4286C16.4416 15.4286 19 12.8702 19 9.71429C19 6.55838 16.4416 4 13.2857 4L9.62 4"
        stroke={stroke ?? customBlue.primaryBlue}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
};
